import { ProviderSelector } from "placement/components/provider-selection/ProviderSelector";
import React from "react";
import { useHistory } from "react-router";
import { ApplicationRootUrl, useApplicationRoot } from "common/component/ApplicationRootContext";
import { setProviderViewAsSession } from "./core/persistence/provider-view-as-state-magement";
import { useForm, FormProvider } from "react-hook-form";

type FormValues = {
    providerGuid: string;
};

export const ProviderSelectionPage = () => {
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const history = useHistory();
    const applicationRoot = useApplicationRoot();
    
    const methods = useForm<FormValues>({
        mode: 'onChange',
        defaultValues: {
            providerGuid: ''
        }
    });

    const onSubmit = async (data: FormValues) => {
        if (!data.providerGuid) return;
        
        setIsSubmitting(true);
        // Store the selected provider guid in session storage
        setProviderViewAsSession(data.providerGuid);
        // Redirect to the provider app root
        const redirectUrlRoot = applicationRoot === ApplicationRootUrl.AZURE_INTERNAL_UM_ROUTE_NAME ? 
            ApplicationRootUrl.AZURE_INTERNAL_UM_PROVIDER_ROUTE_NAME : 
            ApplicationRootUrl.AZURE_INTERNAL_CP_PROVIDER_ROUTE_NAME;

        history.push('/' + redirectUrlRoot);
    };


    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-b from-gray-50 to-gray-100 bg-stripes bg-stripes-gray-200" style={{ backgroundSize: '40px 40px', backgroundImage: 'linear-gradient(45deg, rgba(209, 213, 219, 0.2) 25%, transparent 25%, transparent 50%, rgba(209, 213, 219, 0.2) 50%, rgba(209, 213, 219, 0.2) 75%, transparent 75%, transparent)' }}>
            <div className="w-full max-w-md p-8 space-y-8 bg-white rounded-lg shadow-md">
                <div className="text-center">
                    <h1 className="text-2xl font-bold text-gray-900">Provider Selection</h1>
                    <p className="mt-2 text-sm text-gray-600">
                        Please select a provider to continue
                    </p>
                </div>
                
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-8 space-y-6">
                        <div>
                            <ProviderSelector />
                        </div>
                        
                        <div>
                            <button
                                type="submit"
                                disabled={!methods.watch('providerGuid') || isSubmitting}
                                className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${!methods.watch('providerGuid') || isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-atlantis-200 hover:bg-atlantis-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-atlantis-100'}`}
                            >
                                {isSubmitting ? 'Loading...' : 'Continue'}
                            </button>
                        </div>
                    </form>
                </FormProvider>
            </div>
        </div>
    );
}